import { OFFBOUNDARIES_POI, ERROR_IMPORT } from '../actions/types';

export default function offBoundariesReducer(state = [], action) {
    switch (action.type) {
        case OFFBOUNDARIES_POI:
            return action.payload;
        case ERROR_IMPORT:
            return action.payload;
        default:
            return state;
    }
}